// 2. 定义 state
//    初始值设为 null，表示还没有选择
export var state = {
  printerModel: null
};
// 3. 定义 mutations
//    这是唯一可以修改 state 的地方
export var mutations = {
  /**
   * 设置打印机型号
   * @param state - 当前模块的 state
   * @param {string | null} model - 新的打印机型号
   */
  SET_PRINTER_MODEL: function SET_PRINTER_MODEL(state, model) {
    state.printerModel = model;
  }
};
// 4. 定义 actions
//    组件应该调用这个 action 来更新状态
export var actions = {
  /**
   * 更新打印机型号
   * @param {function} commit - 用于提交 mutation
   * @param {string | null} model - 从组件传递过来的新型号
   */
  setPrinterModel: function setPrinterModel(_ref, model) {
    var commit = _ref.commit;
    commit('SET_PRINTER_MODEL', model);
  }
};
// 5. （可选但推荐）定义 getters
//     方便组件获取状态
export var getters = {
  currentPrinterModel: function currentPrinterModel(state) {
    return state.printerModel;
  }
};
var namespaced = true;
export var equipment = {
  namespaced: namespaced,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};